// *******************************************************************************
// Cart Preview Form Validation
// *******************************************************************************
const resetDeliveryCost = () => {
  const deliveryBox = document.querySelector('.summary-box__row--delivery');
  const defaultDelivery = deliveryBox.getAttribute('data-no-delivery');
  const decodedDeliveryString = decodeURIComponent(defaultDelivery.replace(/\+/g, ' '));
  deliveryBox.innerHTML = decodedDeliveryString;
};

const resetFinalAmount = () => {
  const finalAmount = document.querySelector('.summary-box__row--final-amount');
  const defaultFinalAmount = finalAmount.getAttribute('data-no-delivery');
  const decodedAmountString = decodeURIComponent(defaultFinalAmount.replace(/\+/g, ' '));
  finalAmount.innerHTML = decodedAmountString;
};

const dataIsLoading = (element, isLoading = false) => {
  element?.classList.toggle('is-active', isLoading);
};

const populateAddressList = (response = null) => {
  const checkoutFormEl = document.querySelector('#cart-preview__form');
  const apiData = response?.data?.data;
  const elementsToPopulate = {
    company: apiData?.company || '',
    address_1: apiData?.address || '',
    city: apiData?.city || '',
    postcode: apiData?.zip || '',
    'vat-checkbox': apiData?.taxPayer,
  };

  Object.keys(elementsToPopulate).forEach((key) => {
    const elementToPopulate = checkoutFormEl.querySelector(`[name="${key}"]`);
    const inputWrap = elementToPopulate.closest('.mod-input');
    const errorElement = inputWrap.querySelector('.fv-plugins-message-container');
    elementToPopulate.value = elementsToPopulate[key];
    inputWrap.classList.remove('is-validation-failed');
    inputWrap.classList.toggle(
      'is-disabled',
      (response?.data.data.source === 'SAOP' && elementsToPopulate[key] !== '') || false,
    );
    if (key === 'vat-checkbox') {
      elementToPopulate.checked = elementsToPopulate[key] || false;
      elementToPopulate.disabled = response?.data.data.source === 'SAOP' || false;
    }
    if (errorElement) {
      errorElement.remove();
    }
  });
  // prevent wrong vat number
  const vatInput = checkoutFormEl.querySelector('[name="vat"]');
  if (vatInput) {
    const vatContainer = vatInput.closest('.mod-input');
    if (response) {
      if (vatInput.value) {
        vatContainer.classList.remove('is-validation-failed');
      }
    } else {
      if (!vatInput.value) {
        vatContainer.classList.remove('is-validation-failed');
      } else {
        vatContainer.classList.add('is-validation-failed');
      }
    }
  }
};

const getCompanyData = async (vatNumber, formAction) => {
  if (!vatNumber) {
    populateAddressList(null);
  } else {
    const loadingElement = document.querySelector('.loading');
    dataIsLoading(loadingElement, true);
    const headerNonce = await getNonceForAction(formAction);
    grecaptcha.ready(() => {
      grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
        const dataInput = new FormData();
        dataInput.append('action', formAction);
        dataInput.append('vat', vatNumber);
        dataInput.append('nonce', headerNonce);
        dataInput.append('token', token);

        axios
          .post(localData.apiURL, dataInput, {
            headers: {
              'Content-Type': 'multipart/dataInput',
            },
          })
          .then((response) => {
            populateAddressList(response);
            dataIsLoading(loadingElement);
          })
          .catch(() => {
            populateAddressList();
            dataIsLoading(loadingElement);
          });
      });
    });
  }
};

const contactFormModule = document.querySelector('.cart-preview');
if (contactFormModule) {
  document.addEventListener('DOMContentLoaded', async () => {
    const contactForm = document.getElementById('cart-preview__form');
    const formAction = contactForm.querySelector('input#action').value;
    const vatNumberField = contactForm.querySelector('.payer-form__inner input[name="vat"]');
    vatNumberField.addEventListener('blur', () => {
      getCompanyData(vatNumberField.value, 'getCompanyData');
    });

    const billingAddressFields = contactForm.querySelectorAll('.payer-form__inner input');
    const UserData = {};
    billingAddressFields.forEach((input) => {
      input.addEventListener(
        'blur',
        () => {
          billingAddressFields.forEach((ev) => {
            if (ev.type === 'checkbox') {
              UserData[ev.name] = ev.checked;
            } else {
              UserData[ev.name] = ev.value.trim();
            }
          });
          const formData = {};
          formData.billing = UserData;
          setCookie('wc_userData', JSON.stringify(formData), 1);
        },
        true,
      );
    });

    // Show address list
    const addressRadioButtons = document.querySelectorAll('.shipping-addresses input');
    const addressList = contactFormModule.querySelector('.address-list');
    const addAddressField = document.querySelector('#shipping_another_data');
    addressRadioButtons.forEach((input) => {
      input.addEventListener('change', () => {
        addressList.classList.toggle('show', addAddressField.checked);
        if (addAddressField.checked === false) {
          resetDeliveryCost();
          resetFinalAmount();
          getShippingCost(document.querySelector('form#cart-preview__form #postcode').value);
        }
        if (addAddressField.checked === true) {
          resetDeliveryCost();
          resetFinalAmount();
          const activAddress = document.querySelector('.address-list__item.is-active');
          if (activAddress) {
            getShippingCost(activAddress.querySelector('.address-list__item-postcode').innerHTML.replace(/\D/g, ''));
          }
        }
      });
    });

    const nonce = await getNonceForAction(formAction);
    const axiosCreateOrder = (data) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(localData.captchaSiteKey, { action: formAction }).then((token) => {
          const formErrorMessage = contactForm.querySelector('.form-error-message');
          const checkoutButtonTextEl = contactForm.querySelector('.checkout-button span');
          const buttonText = checkoutButtonTextEl.innerHTML;
          checkoutButtonTextEl.innerHTML = '<div class="load-spinner"></div>';
          const formDataInput = new FormData();
          formDataInput.append('action', formAction);
          formDataInput.append('nonce', nonce);
          formDataInput.append('inputs', JSON.stringify(data));
          formDataInput.append('lang', localData.lang);
          formDataInput.append('id', localData.id);
          formDataInput.append('token', token);
          axios
            .post(localData.apiURL, formDataInput, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then((response) => {
              if (response.status === 200 && response.data.data.redirect === true) {
                window.location.replace(response.data.data.url);
              }
              if (response.status !== 200) {
                if (err.response.data.data.msg) {
                  formErrorMessage.innerHTML = err.response.data.data.msg;
                }
                formErrorMessage.classList.add('is-validation-failed');
                checkoutButtonTextEl.innerHTML = buttonText;
              }
            })
            .catch((err) => {
              if (err.response.data.data?.msg) {
                formErrorMessage.innerHTML = err.response.data.data.msg;
              }
              formErrorMessage.classList.add('is-validation-failed');
              checkoutButtonTextEl.innerHTML = buttonText;
            });
        });
      });
    };

    if (contactForm) {
      const fv = FormValidation.formValidation(contactForm, {
        locale: 'sl_SI',
        localization: FormValidation.locales.sl_SI,
        fields: {},
        plugins: {
          message: new FormValidation.plugins.Message({
            container: (field, element) => element.closest('.mod-input, .checkbox, .radio-button'),
          }),
          declarative: new FormValidation.plugins.Declarative({
            html5Input: true,
          }),
          trigger: new FormValidation.plugins.Trigger(),
          submitButton: new FormValidation.plugins.SubmitButton(),
        },
      })
        .on('core.form.validating', () => {
          fv.addField('shipping');
        })
        .on('core.element.validated', (e) => {
          // e.element presents the field element
          // e.valid indicates the field is valid or not

          // Get the field value
          const value = fv.getElementValue(e.field, e.element);
          const container = FormValidation.utils.closest(e.element, '.mod-input, .checkbox, .radio-button');
          FormValidation.utils.classSet(container, {
            'is-validation-failed': value === '' || !e.valid,
          });
        })
        .on('core.form.valid', () => {
          if (contactForm.querySelector('.is-validation-failed')) {
            return;
          }
          const formData = {};
          const formDataFromInputs = {};
          const billingAddress = contactForm.querySelector('.payer-form__inner');
          billingAddress.querySelectorAll('input, textarea').forEach((input) => {
            if (input.type === 'checkbox') {
              formDataFromInputs[input.name] = input.checked;
            } else {
              formDataFromInputs[input.name] = input.value.trim();
            }
          });

          formData.billing = formDataFromInputs;

          const vatCheckbox = contactForm.querySelector('#vat-checkbox');
          if (vatCheckbox) {
            formData.vatChecked = vatCheckbox.checked;
          }

          const shippingAddressActive = document.querySelector('.address-list.show');
          const shippingAddress = document.querySelector('.address-list__item.is-active');
          if (shippingAddressActive && shippingAddress) {
            const formDataFromShippingInputs = {};
            const addressFields = [
              { key: 'address_1', query: '.address-list__item-address_1' },
              { key: 'address_2', query: '.address-list__item-address_2' },
              { key: 'city', query: '.address-list__item-city' },
              { key: 'country', query: '.address-list__item-state' },
              { key: 'postcode', query: '.address-list__item-postcode' },
            ];
            addressFields.forEach(({ key, query }) => {
              const element = shippingAddress.querySelector(query);
              formDataFromShippingInputs[key] = element ? element.innerHTML.replace(/[\n\t]/g, '') : '';
            });

            formData.shipping = formDataFromShippingInputs;
          }
          setCookie('wc_userData', JSON.stringify(formData), 1);
          axiosCreateOrder(formData);
          contactFormModule.classList.add('show-thankyou');
        });
      initPostCodeHelper(fv, contactForm, true);
    }
  });
}
